import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SearchResultItemComponent } from './search-result-item/search-result-item.component';
import { SearchResultComponent } from './search-result/search-result.component';
import { ButtonModule, CollapseModule, IconModule } from '@vinnova/ui';
import { CommaPipeModule } from '../../pipes/comma/comma-pipe.module';
import { IsValidBisnodeStatusPipeModule } from './../../pipes/bisnode-status/bisnode-status.pipe.module';
import { TranslocoModule } from '@ngneat/transloco';

@NgModule({
  declarations: [SearchResultComponent, SearchResultItemComponent],
  imports: [
    CommonModule,
    CommaPipeModule,
    CollapseModule,
    IsValidBisnodeStatusPipeModule,
    ButtonModule,
    IconModule,
    TranslocoModule,
  ],
  exports: [SearchResultComponent],
})
export class SearchResultModule {}
